import type { ToastRootProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'

import { cn } from '#lib/cn'

import { getRootStylesForPosition } from './styles'
import { ToastPosition } from './types'
import { getSwipeDirectionForPosition } from './utils'

export function ToastRoot({
  className,
  position = ToastPosition.BottomRight,
  swipeDirection,
  ...props
}: ToastRootProps) {
  return (
    <BaseToast.Root
      className={cn(getRootStylesForPosition(position), className)}
      swipeDirection={swipeDirection ?? getSwipeDirectionForPosition(position)}
      {...props}
    />
  )
}
ToastRoot.displayName = 'Toast.Root'
